export default "precision mediump float;\n\nvarying lowp vec4 vColor;\n\nvoid main() {\n    gl_FragColor = vColor;\n}\n"